import React from "react";
import {Helmet} from "react-helmet";
import Newsweek from "../../assets/images/mcluhan/newsweek.png";
import Ivan from "../../assets/images/mcluhan/ivan.png";
import AllanPoe from "../../assets/images/mcluhan/allan-poe.png";
import Playboy from "../../assets/images/mcluhan/playboy.png";
import Mechanical from "../../assets/images/mcluhan/mechanical-bride.png";
import RearView from "../../assets/images/mcluhan/mcluhan-compressed.jpg";

export default function Mcluhan() {
    return (
        <div>
            <Helmet>
                <title>硅谷的幽灵：麦克卢汉从后视镜里看到了什么？ Silicon Valley's Ghost: What did Mcluhan see in the rear view mirror?</title>
            </Helmet>
            <h6 className="App-essay-title">硅谷的幽灵：麦克卢汉从后视镜里看到了什么？</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二六 三月</b>
                <br/><br/>
                <img src={ RearView } alt="Rear-View Mirror" width={'100%'}/><br/><br/>
                <i style={{color: "grey"}}>
                    我们透过后视镜观看当下。我们倒退着迈向未来。<br/>
                    We look at the present through the rear view mirror. We march backwards into the future.<br/>
                    —— 马歇尔 · 麦克卢汉  Marshall Mcluhan
                </i>
                <br/><br/>
                1969年3月，一份封面印着曼妙女郎的《花花公子》杂志（Playboy）被送到成千上万的美国人手里。这份以软色情和贩卖男性感官刺激为生的商业杂志里，夹杂着一份长达万字的严肃对谈：An Interview with Marshall Mcluhan. 采访马歇尔 · 麦克卢汉。
                <br/><br/>
                受访者是一位58岁的加拿大文学教授。
                <br/><br/>
                他经常笃定又高深莫测地抛出一些云山雾绕的词句，什么“媒介即讯息”、“和中文、玛雅文的表意文字不同，英文是一种表音文字，它线性化了视觉元素并切除了听觉”，“电子媒介会让我们退化成部落居民，它把世界变成了地球村”、“延伸即切除”……之类晦涩难懂的“神谕”。
                <br/><br/>
                事实上，在1961年前，除了多伦多大学的英文系学生，以及少数追随他在小发行量学术期刊上晦涩文章的追随者之外，知道马歇尔·麦克卢汉是谁的人并不多。
                <br/><br/>
                但在麦克卢汉51岁和53岁时，两本非同寻常的著作问世了。《古登堡星汉灿烂 》（1962）和《理解媒介：论人的延伸》（1964）。这位来自加拿大西部边陲、两鬓渐灰的教授，很快就被《旧金山纪事报》称为“当下最炙手可热的学术资产”。
                <br/><br/>
                采访麦克卢汉的是《花花公子》的特约记者，埃里克 · 诺登（Eric Norden）。在埃里克面前坐着的这位大学教授，和性感的裸体女郎相去甚远，他写到：
                <br/><br/>
                <i style={{color: "grey"}}>
                    麦克卢汉身材高挑，灰发，四肢瘦长；嘴唇薄却灵活，除此之外面孔几乎让人记不住。他穿着一套不太合身的棕色粗花呢西装、黑皮鞋，以及一条夹扣式领带。我们在噼啪作响的炉火前谈到深夜，麦克卢汉表达了他对这次采访 —— 乃至对印刷文字本身 —— 作为传播方式的保留意见，暗示问答式的采访方式可能妨碍他思想的深入流动。但我向他保证：他有足够的时间 —— 也有足够的篇幅 —— 来展开他的思路。
                </i>
                <br/><br/>
                在这次氛围神秘的访谈中，麦克卢汉第一次用接近正常评论语言的方式，描述了他在《古登堡》和《理解媒介》中华丽深奥、难以破解的格言谜语。或许正是炉火旁的对谈形式，强迫激发了这位萨满巫师的部落体验，让他必须使用更直接和有唤醒感的听觉语言而非咒语般的视觉文字，来展示他对电子技术的深入思考。
                <br/><br/>
                访谈中，他反复表达了一些观点：
                <br/><br/>
                1. 作为表音文字的英文字母出现，把通过听觉为中心的声音和部落篝火时代的集体意识，拖入到以视觉为中心的、线性的个人意识。人们失去了听觉和鼓点组成的部落式的集体记忆，开始喜欢安安静静地一个人读书；
                <br/><br/>
                2. 随着16世纪古腾堡印刷术的出现，印刷品更大大促进了阅读自由，个人意志，科学的线性推理，民族国家和工业流水线的形成，但同时，原子化个体这种强烈的去部落化，也造成了工业文明的身心失调，和表音文字社会中精神分裂率的上升；
                <br/><br/>
                3. 从1844年电报的发明开始，加上广播、电视和计算机的兴起，这类新型的“电子媒介”会破坏线性化的视觉阅读方式，再次将我们推入非线性的时空中，重新让人们走向篝火和群体记忆的再次“部落化”。《花花公子》杂志（Playboy），1969年3月。
                <br/><br/>
                <img src={ Playboy } alt="Rear-View Mirror" width={'100%'}/>
                <br/><br/>
                1969年的故事还远没结束。
                <br/><br/>
                2025年12月22日，临近圣诞节，Ivan Zhao，Notion 创始人 & CEO，在一篇描述AI未来图景的文章中，开头就引用麦克卢汉那句经典的带着迷幻色彩的：“我们总是从后视镜中驶入未来。”
                <br/><br/>
                Ivan是新疆人，出生在乌鲁木齐，16岁移民加拿大。这位CEO身上带着哲学家而非硅谷创业者的气质，这点和他所创造的产品 Notion，一以贯之。
                <br/><br/>
                Steam, Steel, and Infinite Minds: www.notion.com/blog/steam-steel-and-infinite-minds-ai
                <br/><br/>
                文章翻译 - K的博客：www.kunchengblog.com/essay/steam-steel-and-infinite-minds
                <br/><br/>
                <img src={ Ivan } alt="Rear-View Mirror" width={'100%'}/><br/><br/>

                而事实上，Ivan只是麦克卢汉强大粉丝团中的一位。
                <br/><br/>
                麦克卢汉的信徒数不胜数：七八十年代最炙手可热的广告媒体人，嬉皮士运动的领袖，约翰·列侬，《连线》杂志的主编凯文 · 凯利（KK），硅谷风云投资人马克 · 安德森（Marc Andreessen），以及伊隆 · 马斯克。
                <br/><br/>
                这串名单长之又长。
                <br/><br/>
                如果哪个锐意革新的发明家，TA的宣传字典里还没出现“麦克卢汉”的名字，那可能说明他的产品还不够具有“颠覆性”。如果一位精明的投资人，还没有认真研究过麦克卢汉，TA应该小心下次会被人搬出来糊弄。而过去的半个多世纪里，这个世界上最激进的发明家和企业家，从未停止过讨论麦克卢汉和他的概念。
                <br/><br/>
                他像幽灵一样时隐时现。
                <br/><br/>
                如果哪天硅谷这个技术中心，开始停止讨论谁是麦克卢汉和他的观点，那这片曾经的应许之地，就真的开始停止制造新技术、新工具和新事物了。
                <br/><br/>
                在阅读麦克卢汉前，人们觉得他是个彻头彻尾的骗子 —— 而有些人读完后，对此更加深信不疑。毕竟技术专家又不会去找麦克卢汉询问如何制造收音机或电视，甚至电话公司的CEO还直接发过信讽刺他：麦克卢汉，你并不真正理解电话是什么。
                <br/><br/>
                但这不影响他通过一系列呢喃自语式的比喻，神秘又准确地预言着未来。
                <br/><br/><br/>

                <b>1.这帮年轻人到底在干什么？</b>
                <br/><br/>
                镜头拉回到1911年，一名叫马歇尔 · 麦克卢汉的男孩出生在加拿大埃德蒙顿的大草原上。这片加拿大的西北旷野是他童年长大的地方。而他的早年的轨迹毫无成为传播学大师的征兆。他第一年在马尼托巴大学（University of Manitoba）读工程学。然而，那些冰冷的机械公式让他感到无比窒息。他迷上了英语文学，很快就转投文学的怀抱。
                <br/><br/>
                本科毕业后，他去剑桥大学三一学堂从本科读起，重新研究古典文学，等拿到学位毕业，25岁的麦克卢汉回到加拿大。但因为在加拿大找不到工作，他前往美国的威斯康星大学麦迪逊分校担任一名助教。
                <br/><br/>
                这位25岁的年轻助教在威斯康星大学的课堂上，遭遇了滑铁卢。他在给家人的信件中抱怨：讲台下的美国大一新生，对莎士比亚毫无兴趣，反而沉迷于连环画、广告和收音机。
                <br/><br/>
                那时候，他心中的不平和道德优越并没有减少，这一点在他在33年后的花花公子访谈时罕见的袒露心声也能得到应证：
                <br/><br/>
                <i style={{color: "grey"}}>多年来……我对一切环境技术都采取极端道德主义立场：我憎恶机器，我痛恨城市，我把工业革命等同于原罪，把大众媒介等同于堕落。简而言之，我几乎拒绝现代生活的一切元素，转而拥抱一种卢梭式乌托邦主义。</i>
                <br/><br/>
                虽然他牢骚满腹，但这一切的改变，都源于他潜意识里开始的另一个问题：这些粗制滥造的文化垃圾，到底给他们带来了什么，能让这些发光发声的盒子重新接管了年轻人的神经回路？
                <br/><br/>
                这个问题导向的，是他第一本书的诞生。
                <br/><br/><br/>

                <b>2.大众媒体</b>
                <br/><br/>
                1951年，麦克卢汉出版了一本像怪味胡豆般离奇的书，《机械新娘：工业人的民俗》。
                <br/><br/>
                <img src={ Mechanical } alt="Rear-View Mirror" width={'100%'}/><br/><br/>
                在这本书里，他用学院派的分析方法，研究了当时的汽车广告、女性丝袜海报和超人漫画。他尖锐地指出，工业时代的媒介，正在把人变成机器的附庸。然而，这本今天看来极具前瞻性的书，在当时遭到了正统学术界的嘲笑。
                <br/><br/>
                学者们认为研究“广告和漫画”有辱斯文，而麦克卢汉就是个神神叨叨的疯子，把大众文化的垃圾放进经院研究的殿堂。这本书虽然得到过一些支持，但在市场上反响一般。
                <br/><br/>
                而麦克卢汉则显然不这么认为，这本书是他对那些“痴迷发光发声盒子的年轻人”，第一次正面的回应。
                <br/><br/>
                <i style={{color: "grey"}}>
                    我们所处的时代，是第一次有成千上万受过最好训练的头脑，把“钻进公众的集体心智”当作一门全职营生的时代。如今钻进去的目的，是为了操纵、剥削、控制；意图在于制造热度而非光明。许多广告与大量娱乐节目的共同效果，就是让所有人都维持在一种无助的状态 —— 这种无助，是长期精神“发情”所滋生的产物。
                    <br/><br/>
                    沿着这种方法思考时，埃德加·（爱伦）·坡的《陷入大漩涡》总是浮上心头。坡笔下的水手之所以得以自救，是因为他研究了漩涡的运行，并与之配合。本书同样几乎不尝试去正面攻击当下由报刊、广播、电影与广告等机械化机构在我们周围制造的、极其强大的潮流与压力；它确实试图做的，是把读者安置在这些事务所造就的旋转图景的中心，使他能够观察正在进行、且人人身在其中的那种作用过程。希望通过对这种作用的分析，许多个人层面的策略能够自然浮现。但本书很少以盘点这些策略为己任。
                    <br/><br/>
                    （爱伦）坡的水手说，当他被旋转的壁垒与在那种环境中漂浮的众多物体所围困时：“我必定是神志恍惚了，因为我甚至以揣测它们各自向下方泡沫深处沉落时的相对速度为乐。”
                </i>
                <br/><br/>
                记住他最后提到的这个故事。
                <br/><br/><br/>

                <b>3.媒介的巫师</b>
                <br/><br/>
                历史齿轮来到60年代，美国几乎家家都有电视，电视机全面接管了美国家庭生活。一家人盯着这个发光的小盒子看，电视机成了居家生活的中心。刚开始的画面是黑白的，后面变成彩色，而且图像还在变得越来越逼真。人看起来似乎能和电视中的氛围直接互动。
                <br/><br/>
                再过几年，青少年们就要带着收音机和随身听，旁若无人地行走在熙熙攘攘的人群中。然后再过几年，计算机会催生出更多这样的青少年怪客，他们看起来和信号那头不知所云的声音、文字和画面，甚至比和真实世界客观存在的家人与学校都贴得更近。
                <br/><br/>
                这些发光发声的电子媒介，似乎不仅仅是传递信息这么简单 —— 年轻人变得更不易服从，他们似乎感到和远在万里之外的人，更有归属感。
                <br/><br/>
                而仅仅就在60年代末，全球范围的反文化运动爆发的前几年，麦克卢汉最著名的作品《谷登堡星汉灿烂》（1962），《理解媒介》（1964）问世了。
                <br/><br/>
                此时人们突然发现，似乎只有麦克卢汉似癫似狂的格言文字，能解释这一切异常。因此到了60年代末，几乎是一夜之间，他从一个边缘的文学教授，跃升为全球顶级的文化偶像。广告狂人们排着队高价请他“开光”；就连约翰·列侬，和后期美国总统都和他有联系。
                <br/><br/>
                1969年的花花公子采访中，他在炉火边说：
                <br/><br/>
                <i style={{color: "grey"}}>
                    文字的机械社会在空间上把个体从群体中分离出来，从而产生隐私；在思想上分离出来，从而产生“观点”；在劳动上分离出来，从而产生专门化 —— 于是锻造了与个体主义相关的一切价值。
                    <br/><br/>
                    但与此同时，印刷技术又把人同质化，制造了大规模军国主义、大众心智与大规模的一致性；印刷一方面给人私人层面的个体主义习惯，另一方面又给人公共层面的绝对顺从角色。这就是为什么今天的年轻人欢迎再部落化 —— 尽管他们未必清楚自己在欢迎什么 —— 把它当作摆脱文字社会那种一致性、异化与非人化的解放。
                    <br/><br/>
                    印刷在社会上使之集中化，在心理上使之碎片化；而电子媒体把人聚拢到一个部落村落里，那是一个丰富而富创造性的混合体：其中实际上比西方人那种同质化的大众城市社会更有空间容纳创造性和多样性。
                </i>
                <br/><br/>
                1967年3月6日，《新闻周刊》将他印上封面；在那个众人迷茫的电子时代初期，他成了流行文化和大众艺术共同膜拜的“先知”。
                <br/><br/>
                <img src={ Newsweek } alt="Rear-View Mirror" width={'100%'}/><br/><br/>
                麦克卢汉从一个彻头彻尾的神棍和异类，变成了电子时代的萨满巫师。
                <br/><br/><br/>

                <b>4.媒介即信息</b>
                <br/><br/>
                我们今天抱怨社交媒体的烦恼，其实是媒介的烦恼，这件事从古到今都没停止过。
                <br/><br/>
                媒介对生活方式的雕刻能力数千年来都一以贯之。语言没出现的时候，人们通过手把手教导和身体力行的示范，传承着世界上几乎所有知识，那时候的知行合一是如此简单自然，弄虚作假的机会几乎无法存在。
                <br/><br/>
                语言出现后，人们通过口口相传的神话故事和口授经验，延长了知识信息存在时间和方式，媒介的魅惑力开始崭露头角：当一个部落老人随着死亡烟消云散后，有关他的智慧和生平故事的信息仍在源源不断地被语言讲述给素昧平生的年轻人；而这些被传递的知识，也开始有了被语言歪曲的机会，知行不再合一，弄虚作假也有了更大的空间，甚至这个空间里的一部分还变成了艺术。
                <br/><br/>
                苏格拉底就抱怨语言文字是一种药，精心炮制之后会有迷惑人心的力量。
                <br/><br/>
                文字出现后，我们更是把随风飘散的声音记录在莎草纸、竹简、棉箔和蔡伦纸上，而后出现的活字印刷术和古腾堡印刷机，让信息在极其广泛的范围内得以传播和被大众消费，大众媒体的时代在纸张和印刷术就位之后，终于开始了。
                <br/><br/>
                留声机和电影让声音和影像可以被直接永久的固定，文字和绘画第一次受到了重大威胁。电影出现之后，人们能够以前所未有的丰富度复制人生中的一段时空，影象的力量是建设性也是摧毁性的，其中弄虚作假的那部分我们称之为“表演”——或“电影艺术”。等影像的成本变得无比低廉之后，过量的影象和声音充斥着视听，反而让电影这个摧毁文字和绘画的后起之秀，都变成了一种难以咀嚼的艺术（从数量和质量上都是）。所以今天快餐式三分钟看完一部电影的解说栏目会悄然兴起，电影从消解文字绘画的俗物本身变成了被解构的艺术。
                <br/><br/>
                计算机、个人电脑和手机被放进每个凡人手里的那一刻起，声音、文字、图像的生产和传播成本被进一步压缩到不值一提，对生活细节的记录和交流达到了令人恐惧的程度，历史上所有滋生于媒介的艺术都被冲淡了——语言、文学、绘画、摄影、电影——甚至直播寡淡无味的生活本身，都正在变成一门艺术。
                <br/><br/>
                我们不需要单一地鼓吹和批判媒介对人造成的审美和表达蜕化，虽然这是所有人都切身感受到的事实。
                <br/><br/>
                但更客观地说，媒介除了加速人对真实世界的扭曲能力之外，媒介也给人插上了力量巨大的记录和表达能力的翅膀。但媒介绝不只是孤立的工具发明，这些充满魅力的介质是人体装置。无论是记录还是交流，媒介都深深地拓展着人和人的互动能力，它们塑造着我们沟通交流的方式和记录沟通交流的强度大小。
                <br/><br/>
                与此同时，这些魅惑的媒介，还在一刻不停地改造着所有历史时期里，人们倾其全部生命所沟通交流的内容成果，而这，才是媒介最让人无法抗拒的魅惑源泉。
                <br/><br/>
                如同，麦克卢汉言简意赅的先知式描述：
                <br/><br/>
                <i style={{color: "grey"}}>
                    The Medium is the Message. 媒介即信息。
                </i>
                <br/><br/><br/>

                <b>5.冷媒介和热媒介</b>
                <br/><br/>
                媒介动调动了一种感官，还是多种？媒介给了这种感官强烈而清晰的刺激，还是模糊、需要解读和填补的信息？
                <br/><br/>
                这些细微的区别，把媒介分成了两种。
                <br/><br/>
                广播是热媒介，电话和电视是冷媒介。热媒介要求的参与度低，容易煽动；冷媒介要求的参与度高，要求接受者参与补充的信息多。
                <br/><br/>
                麦克卢汉在《理解媒介》中写道：
                <br/><br/>
                <i style={{color: "grey"}}>
                    任何热媒介容许的参与度，比冷媒介容许的参与度都要少，正如讲座比研讨要求较低的参与程度，书本比对谈要求更少的参与度一样。印刷术问世以后，昔日许多形式的媒介被排除在生活和艺术之外，许多新的形式又被赋予新的强度。不过，当代俯拾即是的例子说明了以下的原理：热媒介有排斥性，冷媒介有包容性。
                </i>
                <br/><br/>
                所以收音机可以轻松发动一场革命或战争，电话里大吵大闹的争执往往没有结果，而电视节目中，镇定自若的人会赢得一切。
                <br/><br/>
                肯尼迪就是这样，在1960年，人类历史上第一次电视辩论中击败了尼克松，当选美国总统。
                <br/><br/>
                事实上，麦克卢汉的定义依旧晦涩无比。这也是反对者攻击谩骂的弱点。
                <br/><br/>
                但理解麦克卢汉，不能只用逻辑理解，要用直觉，因为他早已把文字从经院分析式的古板刻意，恢复成了古典式的全能感官。所以，用直觉去感受。
                <br/><br/>
                硅谷著名的另一位先知，凯文 · 凯利（Kevin Kelly），《连线》杂志的第一任主编，他把麦克卢汉称为“守护圣人”（Patron Saint），甚至说自己杂志的整套哲学和理念，都源自麦克卢汉。
                <br/><br/>
                而凯文 · 凯利曾在一个播客中坦言，他自己其实没怎么读过麦克卢汉的书。因为“麦克卢汉不是用来读的，是用来听的”。麦克卢汉当年写作时，是侧躺在沙发上“口述”，由助手记录他说的内容。
                <br/><br/>
                或许这也解释了麦克卢汉文字中先知特征。穿着兽皮裙围着篝火，部落人围坐一圈，在篝火旁听先知讲故事。他用自己的语言，作为媒介的 —— 嘴和口语 —— 比 —— 手和文字 —— 更带有多种感官体验的情绪和性格。
                <br/><br/><br/>

                <b>6.媒介即延伸，延伸即切除</b>
                <br/><br/>
                人类和自己发明的这些工具和媒介到底是什么关系？惯常态度有两种，人类作为机械的主人，我们可以创造、改进、甚至销毁媒介，人主宰着媒介；或者，媒介是人类的主宰，人类进化的历史是被媒介不断异化的历史，人在被媒介驯化。其实，麦克卢汉暗示了更恰当的第三种状态 —— 媒介是人类的延伸，是一种人体装置。
                <br/><br/>
                有一张图片描述移动互联网时代，每个人的手都消失了，手掌的位置是一个iPhone，这张图是人对手机恐惧化的表达，不过并不影响从积极的角度发现这个场景和另一个场景的内在联系。在西班牙的阿尔塔米拉山洞里，旧石器时代的人类描绘了多头栩栩如生的野牛，在这些野牛旁有几个手掌轮廓的图形，大概是那些远古画家的签名。在缺乏工具的时代，那些远古艺术家的手掌似乎有种强烈的欲望，想作为签名媒介牢牢地在石头上留下自己的印记。如同今天的手机，作为一切信息的枢纽，总想牢牢地长在人体末端一样。如同手掌，手机变成了人体装置的一部分，机械成了人体的延伸。相似的，筷子作为一种简单的杠杆机械，就是手指的延伸 —— 防烫伤、保持卫生、延展长度。
                <br/><br/>
                电影钢铁侠里面有一段Tony Stark在国会对峙的场景，国会议员列举了多个理由阐述为何钢铁侠的盔甲是一种武器应该被国家没收，而Tony只嬉皮笑脸地回答，这套钢铁盔甲是我的高科技假肢，你总不能没收我吧。在某种程度上，媒介和人类的关系如同钢铁盔甲和钢铁侠的关系。人注定要和媒介一同演化。
                <br/><br/>
                麦克卢汉的幽灵点点头同意，示意炉火边的麦克卢汉接着讲：
                <br/><br/>
                <i style={{color: "grey"}}>
                    从表音字母到计算机，所有媒介都是人的延伸，会在他身上造成深刻且持久的变化，并改造他的环境。这样的延伸，意味着某种器官、感觉或功能的强化与放大；每当这种延伸发生，中枢神经系统似乎就会对受影响区域启动一种自我保护性的麻木，把它隔离、麻醉，使其不被意识到“正在发生什么”。这过程很像身体在休克或压力之下的反应，也类似弗洛伊德所谓“压抑”的心理机制。
                    <br/><br/>
                    我把这种特殊的自我催眠称为“那喀索斯麻醉”（Narcissus narcosis）：一种综合征，使人对新技术带来的心理与社会效果的无知，正如鱼对它所游之水的无知。结果是：恰恰在由新媒介诱发的环境变得无所不在、并改变我们的感官比例之际，它也变得不可见。
                </i>
                <br/><br/>
                汽车延伸人类的双腿，但一旦超过一定限度，这种延伸就会造成双腿的退化 —— 延伸会转换为“切除”。
                <br/><br/>
                电子媒介大大延伸了人的眼、手、耳，今天的AI延伸了人的大脑和中枢神经。这种延伸会在某一刻开始，变成大脑的切除。
                <br/><br/>
                如果AI延伸大脑的“切除”效应还不够有力，那么想想这个例子：马斯克的Neuralink，猴子，和人体实验。脑机接口正在把这个隐喻变成物理现实。麦克卢汉口中的“切除”曾经是缓慢的，但马斯克正准备用一根比头发丝还细的微型电极，直接物理性地接管那片疆域。
                <br/><br/>
                时钟继续快进，AR、VR、AI、Agent代理、脑机接口，最后一丝残存的、未被增强的人类功能，也会在反复试验中被增强和延伸，直到这种延伸变成一种实质性的切除。
                <br/><br/><br/>

                <b>7.再部落化</b>
                <br/><br/>
                无线电广播把方圆几百公里内的男女老少，通过光速传播的电波聚拢在虚拟想象中的广场上，广场中央坐着播音员 —— 一位巫师，给听众们做法事。因此通过广播，一个恶意的领袖，实实在在地可以“从卧室发起一场革命”。
                <br/><br/>
                甚至有些长波电台，可以传过广阔的空间范围，把不同国家和政治体制的人，通过电信号连接在一起。这些电波所承载的具体信息，甚至没有电波在同一时间内连接起广袤无垠空间中的人这件事本身，所具有的影响力更大。“媒介即信息”对再部落化的过程中，至关重要。
                <br/><br/>
                肯尼迪在电视竞选中大败尼克松，就曾是媒介即信息最有力的证明。电视作为媒介，是比竞选演讲的内容本身，更有决定性的力量。
                <br/><br/>
                所以今天，谁还能嘲笑特朗普的“推特治国”是一种儿戏？整个国家的政治制度及其运作方式，都与运作其上的媒介深度绑定。特朗普比我们绝大多数人更早的发现了其中的奥秘，并对其运用自如。
                <br/><br/>
                是的，我们正在经历比半个世纪前更剧烈的再部落化，这次的媒介是计算机、手机、社交媒体和短视频。
                <br/><br/>
                幽灵表示同意，炉火边的麦克卢汉点点头，接着说：
                <br/><br/>
                <i style={{color: "grey"}}>
                    传统政治系统的重装，只是电媒所带来的再部落化进程的一个表现；这一进程正在把地球变成一个全球村。
                    <br/><br/>
                    我先前提到过，电子技术把我们的中枢神经系统作了技术性的延伸。正是这些延伸把我们浸没在一个信息流动的“世界池”之中，从而使人得以把全人类纳入自身。西方文字人的那种冷漠、游离角色，正在向电子媒介所激发的新的、强烈的深度参与屈服，使我们重新与自己、也与彼此取得联结。
                    <br/><br/>
                    但电信息流动的瞬时性，带来的并非“扩大”人类大家庭，而是“去中心化”：把人类家庭分解成一种由众多部落存在组成的新状态。尤其在那些文字价值深度制度化的国家，这是一种高度创伤性的过程，因为旧的分割式视觉文化与新的整合式电子文化之间的冲突，会制造一场身份危机——自我的真空——进而产生巨大的暴力；而这种暴力不过是一种身份探寻，无论是私人或集体的、社会的或商业的。
                </i>
                <br/><br/>
                社交媒体时代的再部落化并不温和，它带来的更多是冲突和摩擦。而在我们尚未消化上个时代电子媒介的转型阵痛下，我们又正在被迫卷入一个全新的再部落化挑战：后AI时代。
                <br/><br/>

                我们抱怨 AI 会产生“幻觉”（Hallucination）。但麦克卢汉的幽灵这次并不同意。在电子部落里，“真相”（Fact）本来就不重要。印刷时代才讲究线性推理、逻辑关系和事实，而部落时代，社交媒体把碎片化时空中的所有人都卷进来。在这个电子部落里，讲究的是“神话”（Myth）和“同频共振”。
                <br/><br/>
                人们心底里并不在乎AI 制造的幻觉，甚至不认为它是一种技术缺陷，这正是我们退回“部落神话时代”的结构性特征。
                <br/><br/>
                我们创造的AI不是事实的卫兵，反而更像一个会在篝火旁编造故事的老巫师。
                <br/><br/><br/>

                <b>8.终章</b>
                <br/><br/>
                1979年9月，麦克卢汉突发严重中风。这一次中风是毁灭性的，他大脑中控制阅读和语言的中枢区域被损坏。
                <br/><br/>
                这位一辈子都在研究语言、印刷和媒介如何影响人类存在方式的先知，在生命的最后一年里，完全失去了阅读和说话的能力，只能发出几个毫无意义的音节。1980年12月31日，这一年的最后一天，他在一种令人窒息的失语状态中与世长辞。
                <br/><br/>
                在他身边无边无际的空气中，摆放着各式各样的电子设备，无线电信号在不断敲击着房间里这些终端设备，它们把这一连串从电缆和空气中听到的节奏，转化成0和1的节拍，然后再变成声音、文字和图像的符号。这些静默透明的节奏，漫无边际地渗透在他周围：
                <br/><br/>
                滴滴，滴滴，滴—— 滴滴，滴滴，滴——
                <br/><br/>
                这是媒介的声音，也是信息本身。
                <br/><br/><br/>

                <b>9.尾声</b>
                <br/><br/>
                当我们拨开历史，会重新看到一个乱糟糟花白头发的老头，站在旧金山的大街上，继续被这个时代的科技“神”，当做先知崇拜。而他的整个人生，也和媒介塑造的神话故事交织在一起。而这个关于媒体神话力量的传说，依旧在发生，没有丝毫停止的迹象。
                <br/><br/>
                时钟重新拨回2026年，这里充满着炫目吵闹的社交媒体和AI泔水 —— 我们正在陷入部落化的争吵，同时还在丧失仅存的最后一丝注意力。
                <br/><br/>
                就算翻来覆去地读麦克卢汉的全部著作和他格言警句式的观点，在他的喃喃自语中寻找从疯狂现实中解脱的良方 —— 也会像是去问神坛上的大祭司，到底这次祈雨求神的仪式，能不能带来风调雨顺一样。
                <br/><br/>
                麦克卢汉也不知道结果，但他祈求风调雨顺。
                <br/><br/>
                麦克卢汉在给学生、追随者和群众开研讨班时，把自家客厅称作“教练之家”，他反复提到过这个文学隐喻：爱伦 · 坡的水手。而这个故事也出现在他的第一本书，《机械新娘》的开头。
                <br/><br/>
                爱伦 · 坡的水手死里逃生后，对着渔民们讲述他在大漩涡中的故事：
                <br/><br/>
                <i style={{color: "grey"}}>
                    大约在我离船后一个小时，早已远远降到我下面的那条船突然飞速地一连转了三四圈，然后带着我心爱的哥哥，一头扎进了涡底那水沫四溅的深渊，一去不返。而绑着我的那只大木桶只从我跳船入水的位置朝涡底下降了一半多一点儿的距离，这时漩涡的情形起了巨大的变化。涡壁的倾斜度变得越来越小。旋转的速度变得越来越慢。水沫和彩虹渐渐消失，涡底似乎开始徐徐上升。当我发现自己又升回海面之时，天已转晴，风已减弱，那轮灿灿明月正垂悬西天，我就在能望见罗弗敦海岸的地方，就在刚才莫斯肯漩涡的涡洞之上。
                    <br/><br/>
                    当时是平潮期，但飓风的余威仍然使海面卷起小山般的波涛。我猛然被推进了大漩涡的水道，在几分钟内就顺着海岸被冲到了渔民们捕鱼的‘渔场’。一条渔船把我打捞上来，当时我已累得精疲力竭，恐怖的记忆（既然危险已过去）使我说不出话来。
                    <br/><br/>
                    救我上船的那些人都是我的老伙计和经常见面的朋友，可他们居然仅仅把我当作一名死里逃生的游客。我前一天还乌黑发亮的头发当时就已经白成了你现在所看见的这个样子。他们还说我脸上的神情都完全变了。我给他们讲了我那番经历。他们并不相信。现在我讲给你听，可我并不指望你会比那些快活的罗弗敦渔民更相信我的故事。
                </i>
                <br/><br/>
                <img src={ AllanPoe } alt="Rear-View Mirror" width={'100%'}/><br/><br/><br/><br/>

                <b>参考资料 Reference：</b>
                <br/>
                1. Marshall McLuhan Interview from Playboy, 1969. Phillip Rogaway, UC Davis, Course ECS 188.
                <br/>
                2. Suppose he is what he sounds like, the most important thinker since Newton, Darwin, Freud, Einstein, Pavlov. What if he is right? Tom Wolfe. The new life out there, New York Herald Tribune, 1965. Reprinted in The Pump House Gang, 1968.
                <br/>
                3. The Gutenberg Galaxy, 1962. （《古登堡星汉灿烂》 ）
                <br/>
                4. Understanding Media: The Extensions of Man, 1964. （《理解媒介：论人的延伸》）
                <br/>
                5. The Mechanical Bride: Folklore of Industrial Man, 1951. （《机械新娘：工业人的民俗》）
                <br/>
                6. The Medium is the Massage: An Inventory of Effects, 1967, by Marshall McLuhan, co-created with graphic designer Quentin Fiore.
                <br/>
                7. The Techno-Optimist Manifesto, Marc Andreessen The Techno-Optimist Manifesto | Andreessen Horowitz. https://a16z.com/the-techno-optimist-manifesto/
                <br/>
                8.Wired Magazine. Volume 1, issue 1 in March/April 1993. Kevin Kelly. Channeling McLuhan, The Wired Interview with the magazine’s patron saint. www.wired.com/1996/01/channeling/
                <br/>
                9. 莫斯肯漩涡沉浮记，1841， Graham's Magazine. 爱伦 · 坡（Edgar Allan Poe）。
                <br/>
                10. 媒介的魅惑，2023年2月，by K. https://ks-newsletter.com/the-lure-of-medium/
                <br/>
                11. 机械与大革命，2022年5月，by K. https://ks-newsletter.com/machinery-and-revolution/


            </p>

            <br/>

            <h6 className="App-essay-title">Silicon Valley's Ghost: What did Mcluhan see in the rear view mirror?</h6>
            <p className="App-essay-article">
                <br/>
                <b>Mar 2026</b>
                <br/><br/>

            </p>
        </div>)
}
